import {
    USER_DATA_RECEIVED,
    LOGOUT,
    REMOVE_HEADER_FOOTER,
    AUTH_LOADER,
    LOGIN_TRIGGERED,
    WISHLIST_DATA_RECEIVED,
    WISHLIST_LOADER
} from '../actions/types';

const INITIAL_STATE = {
    userData: {
        name: '',
        addresses: [],
        authLoader: false
    },
    removeHeader: false,
    isLoginVisible: false,
    wishlistData: [],
    wishlistLoader: true
};
export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case USER_DATA_RECEIVED:
            return { ...state, userData: action.payload };
        case AUTH_LOADER:
            return { ...state, authLoader: action.payload };
        case REMOVE_HEADER_FOOTER:
            return { ...state, removeHeader: action.payload };
        case LOGIN_TRIGGERED:
            return { ...state, isLoginVisible: action.payload };
        case LOGOUT:
            return { ...state, userData: INITIAL_STATE.userData };
        case WISHLIST_DATA_RECEIVED:
            return { ...state, wishlistData: action.payload };
        case WISHLIST_LOADER:
            return { ...state, wishlistLoader: action.payload };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/auth_reducer.js